import actions from '@/core/store/fornecedor-item-ata/actions'
import mutations from '@/core/store/fornecedor-item-ata/mutations'
import state from '@/core/store/fornecedor-item-ata/state'

export default { actions, mutations, state }
